export const UpperFirstCase = (item) => {
    return typeof item === 'string'
        ? (item = item.substring(0, 1).toUpperCase() + item.substring(1))
        : item
}

export const RemoveDomainFromURL = (item) => {
    return item.replace(/^.*\/\/[^\/]+/, '')
}
